import {Component, ElementRef, inject, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {AnimationController, IonIcon, IonRow, IonText} from '@ionic/angular/standalone';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {DashboardCounterComponent} from '../dashboard-counter/dashboard-counter.component';

@Component({
    selector: 'app-animated-dashboard-counter',
    templateUrl: './animated-dashboard-counter.component.html',
    styleUrls: ['./animated-dashboard-counter.component.css'],
    standalone: true,
    imports: [
        IonIcon,
        IonRow,
        IonText,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardTitle
    ]
})
export class AnimatedDashboardCounterComponent extends DashboardCounterComponent implements OnChanges {
    private readonly animationCtrl: AnimationController = inject(AnimationController);
    @ViewChild(IonRow, {read: ElementRef}) card!: ElementRef<HTMLIonCardElement>;

    protected showArrow = false;
    protected arrowIcon = '';
    private previousCount = 0;

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['count'] && !changes['count'].firstChange) {
            const up = this.count > this.previousCount;
            this.arrowIcon = up ? 'arrow-up' : 'arrow-down';
            this.showArrow = true;

            await this.animationCtrl
                .create()
                .addElement(this.card.nativeElement)
                .duration(1750)
                .iterations(3)
                .keyframes([
                    {offset: 0, transform: 'scale(1)', opacity: '1'},
                    {offset: 0.5, transform: 'scale(1.2)', opacity: '0.3'},
                    {offset: 1, transform: 'scale(1)', opacity: '1'},
                ]).play();

            this.showArrow = false;
        }

        this.previousCount = this.count;
    }

    protected get countDifference(): number {
        return Math.abs(this.count - this.previousCount);
    }

    protected get countDifferenceColor(): string {
        return this.arrowIcon == 'arrow-up' ? 'danger' : 'success';
    }
}
